import type { Location } from 'history';

export const SET_LOCALE = 'SET_LOCALE';
export const FETCH_PAGE_REQUEST = 'FETCH_PAGE_REQUEST';
export const FETCH_PAGE_SUCCESS = 'FETCH_PAGE_SUCCESS';
export const FETCH_PAGE_FAILURE = 'FETCH_PAGE_FAILURE';
export const FETCH_USER_FAILURE = 'FETCH_USER_FAILURE';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const UNLOAD_PAGE = 'UNLOAD_PAGE';

export interface ActionSetLocale {
  type: typeof SET_LOCALE;
}

export interface ActionFetchPageRequest {
  type: typeof FETCH_PAGE_REQUEST;
  pageType: string;
  location: Location;
}

export interface ActionFetchPageSuccess {
  type: typeof FETCH_PAGE_SUCCESS;
  pageType: string;
  data: unknown;
}

export interface ActionFetchPageFailure {
  type: typeof FETCH_PAGE_FAILURE;
}

export interface ActionFetchUserFailure {
  type: typeof FETCH_USER_FAILURE;
}

export interface ActionFetchUserSuccess {
  type: typeof FETCH_USER_SUCCESS;
}

export interface ActionUnloadPage {
  type: typeof UNLOAD_PAGE;
}

export type RoutesActions =
  | ActionSetLocale
  | ActionFetchPageRequest
  | ActionFetchPageSuccess
  | ActionFetchPageFailure
  | ActionFetchUserFailure
  | ActionFetchUserSuccess
  | ActionUnloadPage;
